import { optimisticallyMarkSidebarItemRead } from '#pplx/frontend/apps/ask/hooks/recent-items-query-hooks/sidebar-recent-items-state/sidebarRecentItemsState.js';
import { useAddOrMoveToProjectFactory } from '#pplx/frontend/apps/ask/hooks/sidebar-thread-actions/useAddOrMoveToProject.js';
import { useMarkThreadRead } from '#pplx/frontend/apps/ask/hooks/threads-hooks/useMarkThreadRead.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { useCallback } from 'react';
function noop() { }
const NO_INTERACTIONS = {
    onSelect: noop,
    markRead: noop,
    markUnread: noop,
    addOrMoveToProject: noop,
};
export function useSidebarThreadInteractionsFactory() {
    const { markThreadOpenedFromList, markThreadsRead, markThreadUnread } = useMarkThreadRead({
        reason: 'sidebar thread item',
    });
    const createAddOrMoveToProject = useAddOrMoveToProjectFactory();
    return useCallback((target) => {
        switch (target.kind) {
            case 'no-context':
                return NO_INTERACTIONS;
            case 'thread': {
                const { contextUUID, unread } = target;
                return {
                    onSelect: () => {
                        if (unread)
                            optimisticallyMarkSidebarItemRead(contextUUID);
                        markThreadOpenedFromList({ contextUUID, unread });
                    },
                    markRead: () => {
                        markThreadsRead([contextUUID]);
                    },
                    markUnread: () => {
                        markThreadUnread({ contextUUID, unread });
                    },
                    addOrMoveToProject: createAddOrMoveToProject(target),
                };
            }
            default:
                return assertUnreachableValue(target);
        }
    }, [createAddOrMoveToProject, markThreadOpenedFromList, markThreadsRead, markThreadUnread]);
}
//# sourceMappingURL=useSidebarThreadInteractions.js.map